import React, { useState } from 'react';
import { sendContactForm } from '../services/operations/ContactFormAPI';
import { toast } from 'react-hot-toast';

const Formabout = () => {
    const [formData, setFormData] = useState({
        name: '',
        address: '',
        mobile: '',
        email: '',
        message: ''
    });
    const [loading, setLoading] = useState(false); // Loading state

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true); // Set loading to true during API call
        const toastId = toast.loading('Sending message...');
        try {
            const result = await sendContactForm(formData);
            setLoading(false); // Set loading to false after API call
            if (result.success) {
                toast.success('Message sent successfully!', { id: toastId });
                setFormData({
                    name: '',
                    address: '',
                    mobile: '',
                    email: '',
                    message: ''
                });
            } else {
                toast.error('Failed to send message.', { id: toastId });
            }
        } catch (error) {
            setLoading(false);
            console.error('Error sending contact form:', error);
            toast.error('Error sending message. Please try again.', { id: toastId });
        }
    };

    return (
        <div>
            <form className="space-y-6 mt-2" onSubmit={handleSubmit}>
                <div className="relative">
                    <input
                        type="text"
                        className="block w-full px-4 py-3 bg-transparent border-b-2 border-[#CFB250] text-white focus:outline-none focus:border-white placeholder-transparent peer"
                        placeholder="Your Name"
                        id="name"
                        value={formData.name}
                        onChange={handleChange}
                        disabled={loading}
                    />
                    <label
                        htmlFor="name"
                        className="absolute left-4 top-3 text-[#CFB250] transition-all transform scale-75 -translate-y-6 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                        Your Name
                    </label>
                </div>
                <div className="relative">
                    <input
                        type="text"
                        className="block w-full px-4 py-3 bg-transparent border-b-2 border-[#CFB250] text-white focus:outline-none focus:border-white placeholder-transparent peer"
                        placeholder="Your Address"
                        id="address"
                        value={formData.address}
                        onChange={handleChange}
                        disabled={loading}
                    />
                    <label
                        htmlFor="address"
                        className="absolute left-4 top-3 text-[#CFB250] transition-all transform scale-75 -translate-y-6 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                        Your Address
                    </label>
                </div>
                <div className="relative">
                    <input
                        type="text"
                        className="block w-full px-4 py-3 bg-transparent border-b-2 border-[#CFB250] text-white focus:outline-none focus:border-white placeholder-transparent peer"
                        placeholder="Your Mobile Number"
                        id="mobile"
                        value={formData.mobile}
                        onChange={handleChange}
                        disabled={loading}
                    />
                    <label
                        htmlFor="mobile"
                        className="absolute left-4 top-3 text-[#CFB250] transition-all transform scale-75 -translate-y-6 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                        Your Mobile Number
                    </label>
                </div>
                <div className="relative">
                    <input
                        type="email"
                        className="block w-full px-4 py-3 bg-transparent border-b-2 border-[#CFB250] text-white focus:outline-none focus:border-white placeholder-transparent peer"
                        placeholder="Your Email"
                        id="email"
                        value={formData.email}
                        onChange={handleChange}
                        disabled={loading}
                    />
                    <label
                        htmlFor="email"
                        className="absolute left-4 top-3 text-[#CFB250] transition-all transform scale-75 -translate-y-6 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                        Your Email
                    </label>
                </div>
                <div className="relative">
                    <textarea
                        className="block w-full px-4 py-3 bg-transparent border-b-2 border-[#CFB250] text-white focus:outline-none focus:border-white placeholder-transparent peer"
                        placeholder="Your Message"
                        id="message"
                        rows="4"
                        value={formData.message}
                        onChange={handleChange}
                        disabled={loading}
                    ></textarea>
                    <label
                        htmlFor="message"
                        className="absolute left-4 top-3 text-[#CFB250] transition-all transform scale-75 -translate-y-6 peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-6"
                    >
                        Your Message
                    </label>
                </div>
                <button
                    type="submit"
                    className={`w-full px-6 py-3 rounded-md focus:outline-none focus:ring-2 focus:ring-[#CFB250] transition duration-300 ease-in-out ${
                        loading
                            ? 'bg-gray-400 cursor-not-allowed'
                            : 'bg-[#CFB250] text-black hover:bg-black hover:text-[#CFB250]'
                    }`}
                    disabled={loading}
                >
                    {loading ? 'Sending...' : 'Send Message'}
                </button>
            </form>
        </div>
    );
};

export default Formabout;
